module.exports = __webpack_public_path__ + "img/9788936509149.74a6a0b5.jpg";